import { Avatar, Text, Group, Button, Stack, Flex, Paper } from "@mantine/core"
import { type ScheduleEvent } from "../../shared/types/scheduleEvent"
import { API_URL } from "../../shared/config"
import React, { type Dispatch, type SetStateAction } from "react"
import { DraftScheduleEventStore } from "../../app/store"

// ----------------------------------------------------------------------


type Props = {
  setDraft: Dispatch<SetStateAction<ScheduleEvent | null>>
  close: () => void
  draft: ScheduleEvent
}

export function ScheduleDraftElementCard({ close, setDraft, draft }: Props): React.JSX.Element {
  const { instructor, title, level, _id } = draft

  const handleRemove = () => void DraftScheduleEventStore.removeDraft(_id)
  const chooseDraft = () => {
    setDraft(JSON.parse(JSON.stringify(draft)) as ScheduleEvent)
    close()
  }

  return (
    <Paper mx={2} mb="xl" withBorder radius="md" py="sm" px="md">
      <Stack spacing="md">
        <Text fz="lg" fw={500}>
          {title}
        </Text>

        {level && (
          <Text size="sm" c="dimmed">
            {level === "based" ? "Базовый" : "Продвинутый"} уровень
          </Text>
        )}

        <Flex align="center" gap="sm">
          <Avatar src={`${API_URL}/media/${instructor?.avatar}`} size={36} radius="sm"/>
          <Text fz="sm">
            {instructor?.name ?? "Не назначен"}
          </Text>
        </Flex>

        <Group position="center">
          <Button onClick={chooseDraft} size="xs" radius="md" variant="light">Использовать</Button>
          <Button onClick={handleRemove} size="xs" radius="md" variant="light" color="red">Удалить</Button>
        </Group>
      </Stack>
    </Paper>
  )
}
